import './ReceptionDetailForm.scss';

import { Form, FormProps, Input, Radio } from 'antd';
import { SelectProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import CompanySelectField from '@/components/general/CompanySelectField';
import { useCountryContext } from '@/contexts/CountryContext';

interface ReceptionDetailFormProps {
  formProps: FormProps;
  companySelectProps: SelectProps;
  shippersSelectProps: SelectProps;
}

const ReceptionDetailForm = (props: ReceptionDetailFormProps) => {
  const { t } = useTranslation();
  const { isBrasilSelected } = useCountryContext();
  const { formProps, companySelectProps, shippersSelectProps } = props;

  return (
    <>
      <div className="ReceptionFormRow">
        <CompanySelectField
          name="company"
          label={t('Empresa o Técnico que envía el paquete')}
          formProps={formProps}
          selectProps={{ ...companySelectProps, loading: companySelectProps.loading }}
          rules={[
            {
              required: true,
              message: t('La {{field}} es requerida', { field: t('Empresa') }),
            },
          ]}
          required
        />
      </div>

      <div className="ReceptionFormRow">
        <Form.Item
          label={t('Operador logístico')}
          name={'shipper'}
          rules={[
            {
              required: true,
              message: t('El operador logístico es requerido'),
            },
          ]}>
          <AntdSelect {...shippersSelectProps} allowClear showSearch />
        </Form.Item>
        <Form.Item label={t('Número de seguimiento')} name={'tracking_number'}>
          <Input />
        </Form.Item>
      </div>
      <Form.Item
        label={t('Retiro en deposito')}
        name={'has_to_be_picked_up'}
        layout="horizontal"
        rules={[{ required: true, message: t('Este campo es requerido') }]}>
        <Radio.Group>
          <Radio value={true}>{t('Sí')}</Radio>
          <Radio value={false}>{t('No')}</Radio>
        </Radio.Group>
      </Form.Item>
      {isBrasilSelected && (
        <Form.Item
          label={t('Proceso de logística inversa')}
          name={'reversed_logistic'}
          layout="horizontal"
          rules={[{ required: true, message: t('Este campo es requerido') }]}>
          <Radio.Group>
            <Radio value={true}>{t('Sí')}</Radio>
            <Radio value={false}>{t('No')}</Radio>
          </Radio.Group>
        </Form.Item>
      )}
    </>
  );
};

export default ReceptionDetailForm;
